import templateUrl from 'emun.vendor/stripe/stripe-refresh.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals'

class StripeRefreshController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		    $ctrl.bus = new ServiceBus();
        $ctrl.bus
        .send("QueryVendors.json?Active=1&Id=" + $ctrl.vendorId)
        .then(function(res) {
          if (res.data.results.length > 0) $ctrl.vendor = res.data.results[0];
        });
    }

    resumeStripe() {
      const $ctrl = this;
      $ctrl.bus.send("Stripe/CreateAccountLink", {
        VendorId: $ctrl.vendorId,
        AccountId: $ctrl.accountId
      }).then(function(res) {
        if (res.data.url) {
          window.location = res.data.url;
        }
      });
    }
  
}

export default {
	bindings: {
        accountId: '@',
        vendorId: '@'
	},
    controller: StripeRefreshController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};